(function (aimi_campaign, $, app, undefined) {

  app.apis['campaign'] = function () {
    return {
      'list': function (calendarId) {
        return app.getRequest(`/api/user/calendars/campaigns/${calendarId}`, {}, function () {
        }, function () {
        });
      },
      'get': function (id) {
        return app.getRequest(`/api/post/campaign/${id}`, {}, function () {
        }, function (response) {
          app.notify('error', response);
        });
      },
      'delete': function (id) {
        return app.deleteRequest(`/api/post/campaign/${id}`, {}, function () {
        }, function (response) {
          app.notify('error', response);
        });
      },
      'getCampaignByCategory': function (categoryId) {
        return app.getRequest(`/api/campaign/campaign/by-category/${categoryId}`, {}, function () {
        }, function () {
        });
      },
      'imageCollections': function (id) {
        return app.getRequest(`/api/image/collection/by-app-campaign/${id}`, {}, function () {
        }, function () {
        });
      },
      'add': function (requestData) {
        return app.postRequest(`/api/post/campaign`, requestData, function () {
        }, function () {
        });
      },

      'update': function (id, requestData) {
        return app.putRequest(`/api/post/campaign/${id}`, requestData, function () {
        }, function () {
        });
      },

      'save': async function (requestData) {
        if (app.isEmpty(requestData.id)) {
          return this.add(requestData)
        } else {
          return this.update(requestData.id, requestData)
        }
      },

      'reset': function (id, requestData) {
        return app.putRequest(`/api/post/campaign/reset/${id}`, requestData, function () {
        }, function () {
        });
      },
      'categories': function (businessProfileId) {
        return app.getRequest(`/api/category/${businessProfileId}`, {}, function () {
        }, function () {
        });
      },
      build: function (campaignId, partial = false, keepScheduled = false) {
        let url  = `/api/post/build/`;
        url = `${url}${campaignId}?partial=${partial}&keepScheduled=${keepScheduled}`;
        return app.getRequest(url, {}, function () {
        }, function () {
        });
      }
    }
  }();

}(window.aimi_campaign = window.aimi_campaign || {}, jQuery, PreBuilt));
